// extracted by mini-css-extract-plugin
export default {"text":"VerifiedUserToast_text--UMx","toast":"VerifiedUserToast_toast--_Ym"};